module.exports = __webpack_public_path__ + "img/logo-white.f33ec984.svg";